import React, { useState } from 'react'
import './input.css'

// Icono de ojo (mostrar contraseña)
const EyeIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
    <circle cx="12" cy="12" r="3"></circle>
  </svg>
)

// Icono de ojo tachado (ocultar contraseña)
const EyeOffIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
    <line x1="1" y1="1" x2="23" y2="23"></line>
  </svg>
)

export const Input = ({ type = 'text', id, placeholder, useRef, className = '' }) => {
  return (
    <input
      className={`form-input ${className}`}
      type={type}
      id={id}
      placeholder={placeholder}
      autoComplete={type === 'email' ? 'username' : undefined}
      ref={(el) => (useRef.current[id] = el)}
    />
  )
}

export const InputPassword = ({ id, placeholder, useRef }) => {
  const [showPassword, setShowPassword] = useState(false)

  return (
    <>
      <input
        name="password"
        type={showPassword ? 'text' : 'password'}
        className="form-input"
        placeholder={placeholder || 'Tu contraseña'}
        ref={(el) => (useRef.current[id] = el)}
        autoComplete="current-password"
      />
      <div style={{ position: 'relative' }}>
        <button
          type="button"
          onClick={() => setShowPassword(!showPassword)}
          className="forn-input-eye"
        >
          {showPassword ? <EyeIcon /> : <EyeOffIcon />}
        </button>
      </div>
    </>
  )
}

export const Label = ({ value, className = '' }) => (
  <label className={`form-label ${className}`}>{value}</label>
)
